import { CurrencyPipe, DecimalPipe } from "@angular/common";
import { Component } from "@angular/core";
import { RouterModule } from "@angular/router";
import { ServiciosService } from "src/app/core/services/servicios.service";

@Component({
  selector: "app-listado-paquetes",
  standalone: true,
  imports: [CurrencyPipe, DecimalPipe, RouterModule],
  templateUrl: "./listado-paquetes.component.html",
  styleUrl: "../../../app.component.scss",
})
export class ListadoPaquetesComponent {
  listadoPaquetes: any;
  userLocal: boolean = true;
  constructor(private __serviciosService: ServiciosService) {}

  ngOnInit(): void {
    const currentUser = localStorage.getItem("currentPatient");
    console.log("currentUser", currentUser);
    if (currentUser) {
      this.userLocal = JSON.parse(currentUser).local;
    }
    this.getListadoPaquetes();
  }

  getListadoPaquetes() {
    this.__serviciosService.getPaquetes().then((paquetes: any) => {
      this.listadoPaquetes = paquetes;
      console.log("listado", this.listadoPaquetes);
    });
  }
}
